<template>
  <div id="users">
    <div v-if="hasError" class="error center-element">
      Error: {{ errorMessage }}<br />
    </div>
    <div v-if="currentStep == 1" id="alerts">
      <h1>Upgrade Plan</h1>
      <span v-if="!plans.length">No Subscription Plans</span>
      <div class="steps-container">
        <ul class="steps-progressbar">
          <li class="step-active">select plan</li>
          <li>select payment</li>
          <li>confirmation</li>
        </ul>
      </div>
      <div class="box-container">
        <div v-for="plan in plans" :key="plan.id" class="box">
          <span v-if="plan.is_current_plan" class="current-plan">
            Your current plan is {{ plan.name }}
          </span>
          <span v-else>
            <h1>{{ plan.name }} Plan</h1>
            {{ plan.description }}<br />
            ${{ plan.billing_term_cost }}.00 / month<br />
            Length of Plan: {{ plan.plan_term_months }} months<br />
            Number of Properties Allowed: {{ plan.limit_property }}<br />
            Number of Users Allowed: {{ plan.limit_user }}<br />
            <br />
            <div class="center-text">
              <a
                href="#"
                class="button button-150 "
                @click.prevent="upgradePlan(plan.id)"
                >Upgrade</a
              >
            </div>
          </span>
        </div>
      </div>
      <v-dialog />
    </div>
    <BillingMethodsList
      v-if="currentStep == 2"
      header-title="Upgrade Plan: Select a Payment Method"
      @select-billing="billingSelected"
      @cancel-billing="cancelBilling"
    />
    <ConfirmUpgradeComponent
      v-if="currentStep == 3"
      :plan="selectedPlan"
      :billing="accountBillingID"
      @confirm-upgrade="upgradeConfirmed"
      @cancel="cancelUpgrade"
    />
  </div>
</template>

<script>
import BillingMethodsList from "@/components/BillingMethodsList.vue";
import ConfirmUpgradeComponent from "@/components/UpgradeConfirmation.vue";
import api from "@/api/index";
const apiServiceSubscription = new api.APIServiceSubscription();

export default {
  name: "SubscriptionUpgrade",
  components: {
    BillingMethodsList,
    ConfirmUpgradeComponent
  },
  data() {
    return {
      currentStep: 1,
      selectedPlan: 0,
      accountBillingID: 0,
      hasError: false,
      errMessage: "",
      plans: []
    };
  },
  computed: {
    // plans () {
    //   return this.$store.getters.plansUpgrade;
    // },
    errorMessage() {
      if (this.errMessage !== "") {
        return this.errMessage;
      }
      return "Error Upgrading Subscription Plan.";
    }
  },
  created() {
    this.getSubscriptionUpgrade();
    // this.$store.dispatch('getSubscriptionUpgrade', this.$route.params.id);
  },
  methods: {
    getSubscriptionUpgrade: function() {
      apiServiceSubscription.getSubscriptionUpgrade().then(data => {
        if (data) {
          this.plans = data.data;
        }
      });
    },
    upgradePlan: function(planID) {
      // console.log('upgrade plan ' + planID);
      this.selectedPlan = planID;
      this.currentStep = 2;
    },
    billingSelected: function(accountBillingID) {
      // console.log(accountBillingID);
      this.accountBillingID = accountBillingID;
      this.currentStep = 3;
      // run the upgrade of the account - moved to confirmation
      // this.doUpgrade();
    },
    upgradeConfirmed: function() {
      // call do upgrade then go back to account dashboard
      // on error show the error
      this.doUpgrade();
    },
    cancelUpgrade: function() {
      this.selectedPlan = 0;
      this.accountBillingID = 0;
      this.currentStep = 1;
    },
    cancelBilling: function() {
      this.currentStep = 1;
    },
    doUpgrade: function() {
      let payload = {
        plan_id: this.selectedPlan,
        account_billing_id: this.accountBillingID
      };
      apiServiceSubscription
        .upgradeSubscription(payload)
        .then(data => {
          this.$router.push("/console/account");
        })
        .catch(error => {
          this.hasError = true;
          this.errMessage = error;
        });
      // this.$store.dispatch('upgradeSubscription', payload).then(result => {
      //   // get the plans again - need to go back to account page
      //   // this.$store.dispatch('getSubscriptionUpgrade', this.$route.params.id);
      //   this.$router.push('/console/dashboard/account');
      // }).catch(error => {
      //   this.hasError = true;
      //   this.errMessage = error;
      // });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 18px;
}
h3 {
  font-size: 18px;
  margin-bottom: 0;
}
#alerts {
  lost-utility: clearfix;
}
.box-container {
  width: 100%;
  margin-top: 40px;
  lost-column: 1/1;
}
.box {
  lost-column: 1/3;
  background: #d5e3f4;
  padding: 15px;
  border-radius: 4px;
  lost-utility: clearfix;
  margin-bottom: 20px;
}
.steps-container {
  width: 100%;
  margin: 30px auto;
}
.steps-progressbar {
  margin: 0 auto;
  width: 60%;
  text-align: center;
  counter-reset: step;
}
.steps-progressbar li {
  list-style-type: none;
  width: 33%;
  float: left;
  font-size: 12px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  color: #7d7d7d;
}
.steps-progressbar li:before {
  width: 30px;
  height: 30px;
  content: counter(step);
  counter-increment: step;
  line-height: 30px;
  border: 2px solid #7d7d7d;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background-color: white;
}
.steps-progressbar li:after {
  width: 100%;
  height: 2px;
  content: "";
  position: absolute;
  background-color: #7d7d7d;
  top: 15px;
  left: -50%;
  z-index: -1;
}
.steps-progressbar li:first-child:after {
  content: none;
}
.steps-progressbar li.step-active {
  color: #5584c0;
}
.steps-progressbar li.step-active:before {
  border-color: #5584c0;
}
.steps-progressbar li.step-active + li:after {
  background-color: #5584c0;
}
@media (max-width: 800px) {
  .box {
    lost-column: 1/1;
  }
  .steps-progressbar {
    width: 80%;
  }
}
@media (max-width: 640px) {
  .box {
    lost-column: 1/1;
  }
  .steps-progressbar {
    width: 90%;
  }
}
</style>
